module.exports = __webpack_public_path__ + "img/kyouzai_satori.574ec559.png";